<p class="muted align-responsive">
  Acesse o <strong>sistema Abrapa Convites</strong> para consultar ou convidar
  usuários.
</p>
